/**
 * SEO Configuration
 * Update these values with your actual domain and store information
 */

export const SEO_CONFIG = {
  // Store Information
  storeName: 'Didohurtownia',
  storeDescription: 'Sklep internetowy z zabawkami z szeroką ofertą produktów dla dzieci. Oferujemy szybką dostawę, darmową dostawę przy zamówieniach od 2000 zł oraz ofertę zawsze aktualizowaną o nowe i popularne zabawki. Wygodne i bezpieczne zakupy online.',
  
  // Domain Configuration
  domain: 'https://didohurtownia.com',
  
  // Social Media
  ogImage: '/og-image.jpg', // Relative to domain
  twitterHandle: '@didohurtownia', // Optional
  
  // Contact
  supportEmail: 'dungcohoi1998@gmail.com',
  
  // Logo
  logoUrl: '/logo.png', // Relative to domain
  
  // SEO Keywords (default for homepage)
  defaultKeywords: 'zabawki, maskotki, klocki, magnetyczne zabawki, drewniane zabawki, szybka dostawa',
} as const;

/**
 * Helper function to get full URL
 */
export const getFullUrl = (path: string = ''): string => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${SEO_CONFIG.domain}${cleanPath}`;
};

/**
 * Helper function to get full image URL
 */
export const getFullImageUrl = (imagePath: string): string => {
  if (imagePath.startsWith('http')) {
    return imagePath; // Already a full URL
  }
  return getFullUrl(imagePath);
};
